module.exports = __webpack_public_path__ + "hospitality.2RN8JS0h.svg";